module.exports = __webpack_public_path__ + "static/media/YF88_4.a4644e8b.jpg";